<!--<dx-scroll-view>-->
<!--<app-settings-form></app-settings-form>-->
<router-outlet></router-outlet>
<!--</dx-scroll-view>-->
